import _classCallCheck from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { FieldPosition } from "./FieldPosition";
export var Field = /*#__PURE__*/function () {
  function Field(_ref) {
    var name = _ref.name,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? FieldPosition.HEADER : _ref$kind,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values;
    _classCallCheck(this, Field);
    this.name = name;
    this.kind = kind;
    this.values = values;
  }
  _createClass(Field, [{
    key: "add",
    value: function add(value) {
      this.values.push(value);
    }
  }, {
    key: "set",
    value: function set(values) {
      this.values = values;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      this.values = this.values.filter(function (v) {
        return v !== value;
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.values.map(function (v) {
        return v.includes(",") || v.includes(" ") ? "\"".concat(v, "\"") : v;
      }).join(", ");
    }
  }, {
    key: "get",
    value: function get() {
      return this.values;
    }
  }]);
  return Field;
}();